import Swiper, { Autoplay, Navigation } from 'swiper';
import "swiper/css";

if (document.getElementById("ProjectGallery")) {
    const slider = new Swiper("#ProjectGallery .swiper", {
        modules: [Autoplay, Navigation],
        slidesPerView: "auto",
        loopedSlides: 2,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: ".custom-swiper-button-next",
            prevEl: ".custom-swiper-button-prev",
        },
    });
}